import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import styles from "./style.module.css";

const stores = [
  { name: "Azercell Şamaxı Eksklüziv", url: "https://azercellexclusiveshamakhi.simsim.az" },
  { name: "Azercell Quba Eksklüziv", url: "https://azercellexclusivequba.simsim.az" },
  { name: "Azercell Xaçmaz Eksklüziv", url: "https://azercellexclusivekhachmaz.simsim.az" },
  { name: "Bakcell Şamaxı", url: "https://simsim.az" },
  { name: "Mağaza #4\n(Yaxında Əlavə Ediləcək)", url: "https://simsim.az" },
  { name: "Mağaza #5\n(Yaxında Əlavə Ediləcək)", url: "https://simsim.az" },
];

const Stores = () => {
  return (
    <Container fluid className={styles.storeContainer}>
      <h1 className={styles.title}>Bizi Seçən Mağazalar</h1>
      <Row className={styles.storeRow}>
        {stores.map((store, index) => (
          <Col key={index} xs="auto" className={styles.storeCol}>
            <Card className={styles.storeCard}>
              <Card.Body className={styles.storeCardBody}>
                <Card.Title className={styles.storeTitle}>{store.name}</Card.Title>
                <Button variant="primary" className={styles.storeButton} href={store.url} target="_blank">
                  Mağazaya Keçid Et
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Stores;
